import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="New-footer-container">
    <ul className="New-list-unstyled">
      <a href="#" alt="">
        <img
          src={require("../../Pages/images/newHCCLogo.png")}
          alt="Hyderabad Casting Club Logo"
          className="logo"
        />
      </a>
      {/* Nav links */}
      <li><a href="/home">Home</a></li>
      <li><a href="/about-us" target="_blank">About</a></li>
      <li><a href="/s">Profile</a></li>
      <li><a href="/auditions">Auditions</a></li>
      <li><a href="/terms-conditions" target="_blank">Terms and Conditions</a></li>
      <li><a href="/refund-policy" target="_blank">Refund Policy</a></li>
      <li><a href="/privacy-policy" target="_blank">Privacy Policies</a></li>
      <li><a href="/child-safety-policy" target="_blank">Child Safety Policy</a></li>
      <li><a href="/contact-us" target="_blank">Contact Us</a></li>
    </ul>
  
    <div className="botton-footer">
      <p className="text-powered mb-0">
        Copyright &copy; 2024 All Rights Reserved.{" "}
        <a href="https://hyderabadcastingclub.com/">Hyderabad Casting Club</a>
      </p>
  
      <div className="d-flex gap-1">
        <a href="https://www.facebook.com/hydcastingclub?mibextid=ZbWKwL" target="_blank">
          <img src={require("./images/facebook.png")} alt="Facebook" />
        </a>
        <a href="https://www.instagram.com/hydcastingclub?igsh=MWN2Nzh5ejRkd3N2NA==" target="_blank">
          <img src={require("./images/instagram.png")} alt="Instagram" />
        </a>
        <a href="https://api.whatsapp.com/send?phone=917799234563&text=Hi+I+want+to+know+more+about+Hyderabad+Casting+Club" target="_blank">
          <img src={require("./images/whatsapp.png")} alt="WhatsApp" />
        </a>
      </div>
    </div>
  </div>
  
  );
};

export  {Footer};
